var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "permission-toggle",
      class: {
        active: _vm.isActive,
        disabled: _vm.isDisabled,
      },
      on: { click: _vm.toggle },
    },
    [_c("span", { staticClass: "material-icons" }, [_vm._v("check")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }